import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { EpisodeOfCareService } from './episodeOfCare.service';
import { PatientService } from './patient.service';

@Injectable({ providedIn: 'root' })
export class DepartmentalQuestionnairesService {
  public departmentalQuestionnairesModalSub = new BehaviorSubject<boolean>(
    false,
  );

  public departmentalQuestionnairesEditSub = new BehaviorSubject<
    any | undefined
  >(undefined);

  public departmentalQuestionnairesDataSub = new BehaviorSubject<any[]>([]);

  public departmentalQuestionnairesSub = new BehaviorSubject<boolean>(false);
  public departmentalQuestionnairesLoadingSub$ =
    this.departmentalQuestionnairesSub.asObservable();

  constructor(
    private readonly _http: HttpClient,
    private readonly eocService: EpisodeOfCareService,
    private readonly patientService: PatientService,
  ) {}
}
